export default __webpack_public_path__ + "static/media/testimonial-6-2.21f2048f.jpg";